import styled from 'styled-components'
import { stripHtml, px2rem } from '@utils'
import { Text, AddEventCalendar } from '@components'
import { Icon, ButtonIcon } from '@mch-group/uikit-components'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { FC } from 'react'

const EventDetailButtons: FC<IEventDetailButtons> = ({ data, exportToCalLabel }) => (
  <>
    {!data.exhibition && data.openingDateTimes && data.openingDateTimes.length > 0 && (
      <StyledListItem className='gap-4'>
        <div>
          <Icon name='calendar' />
        </div>
        <div>
          <Text isSmall>
            {/* @ts-ignore */}
            <AddEventCalendar
              title={data.title}
              description={stripHtml(data.longParagraphText || '')}
              startTime={`${data.openingDateTimes[0].date} ${data.openingDateTimes[0].startTime}`}
              endTime={
                !data.openingDateTimes[0].endTime
                  ? `${data.openingDateTimes[0].date} 23:59`
                  : `${data.openingDateTimes[0].date} ${data.openingDateTimes[0].endTime}`
              }
              timezoneId={data.timezoneId}
              text={exportToCalLabel}
              virtual={data.virtual}
              virtualUrl={data.virtualUrl}
              location={
                data.venue &&
                ['name', 'street', 'street2', 'city', 'postCode', 'country']
                  .map((item) => data.venue[item])
                  .filter(Boolean)
                  .join(', ')
              }
              shareIcon={<ButtonIcon icon='calendar' className='icon' title='Add event to Calendar' />}
            />
          </Text>
        </div>
      </StyledListItem>
    )}
  </>
)

const StyledListItem = styled.div`
  --border-specs: ${px2rem(0.5)} solid ${tokens.color.light.base.neutrals['300'].value};

  cursor: pointer;
  margin: ${px2rem(32)} 0 !important;
  padding: ${px2rem(16)} 0 !important;
  border-bottom: var(--border-specs);

  &:first-child {
    border-top: var(--border-specs);
  }

  display: flex;
`

interface IEventDetailButtons {
  data: any,
  setToFavLabel: string,
  exportToCalLabel: string
}

export default EventDetailButtons
